"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimApiV1Message = exports.ClaimApiV1Document = exports.eCauseOfTemperatureRelatedIssue = exports.eCauseOfDamage = exports.eClaimApiV1Parties = exports.eClaimApiV1ClaimAction = exports.eClaimApiV1ClaimStatus = exports.eClaimApiV1DocumentType = exports.eClaimApiV1CauseOfLoss = exports.eClaimApiV1DeliveryNoteOrBolComments = void 0;
const user_1 = __importDefault(require("../../user"));
var eClaimApiV1DeliveryNoteOrBolComments;
(function (eClaimApiV1DeliveryNoteOrBolComments) {
    eClaimApiV1DeliveryNoteOrBolComments["ITEMS_RECEIVED_DAMAGED"] = "ITEMS_RECEIVED_DAMAGED";
    eClaimApiV1DeliveryNoteOrBolComments["PACKAGING_DAMAGED"] = "PACKAGING_DAMAGED";
    eClaimApiV1DeliveryNoteOrBolComments["ITEMS_MISSING"] = "ITEMS_MISSING";
    eClaimApiV1DeliveryNoteOrBolComments["PREEXISTING_DAMAGE_OR_INSUFFICIENT_PACKAGING"] = "PREEXISTING_DAMAGE_OR_INSUFFICIENT_PACKAGING";
    eClaimApiV1DeliveryNoteOrBolComments["DAMAGE_DURING_UNLOADING"] = "DAMAGE_DURING_UNLOADING";
    eClaimApiV1DeliveryNoteOrBolComments["NO_NOTES_GIVEN"] = "NO_NOTES_GIVEN";
    eClaimApiV1DeliveryNoteOrBolComments["OTHER"] = "OTHER";
})(eClaimApiV1DeliveryNoteOrBolComments = exports.eClaimApiV1DeliveryNoteOrBolComments || (exports.eClaimApiV1DeliveryNoteOrBolComments = {}));
var eClaimApiV1CauseOfLoss;
(function (eClaimApiV1CauseOfLoss) {
    eClaimApiV1CauseOfLoss["DAMAGE_BENDING_OR_TWISTING"] = "DAMAGE_BENDING_OR_TWISTING";
    eClaimApiV1CauseOfLoss["DAMAGE_BREAKAGE"] = "DAMAGE_BREAKAGE";
    eClaimApiV1CauseOfLoss["DAMAGE_BURSTING_OR_TEARING"] = "DAMAGE_BURSTING_OR_TEARING";
    eClaimApiV1CauseOfLoss["DAMAGE_COLLISION_OR_OVERTURN"] = "DAMAGE_COLLISION_OR_OVERTURN";
    eClaimApiV1CauseOfLoss["DAMAGE_CONTAMINATION"] = "DAMAGE_CONTAMINATION";
    eClaimApiV1CauseOfLoss["DAMAGE_CRUSHING"] = "DAMAGE_CRUSHING";
    eClaimApiV1CauseOfLoss["DAMAGE_DENTING"] = "DAMAGE_DENTING";
    eClaimApiV1CauseOfLoss["DAMAGE_FIRE"] = "DAMAGE_FIRE";
    eClaimApiV1CauseOfLoss["DAMAGE_FORKLIFT_DAMAGE"] = "DAMAGE_FORKLIFT_DAMAGE";
    eClaimApiV1CauseOfLoss["DAMAGE_LEAKAGE"] = "DAMAGE_LEAKAGE";
    eClaimApiV1CauseOfLoss["DAMAGE_MARRING_OR_SCRATCHING"] = "DAMAGE_MARRING_OR_SCRATCHING";
    eClaimApiV1CauseOfLoss["DAMAGE_ROUGH_HANDLING"] = "DAMAGE_ROUGH_HANDLING";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_BENDING_OR_TWISTING"] = "CONCEALED_DAMAGE_BENDING_OR_TWISTING";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_BREAKAGE"] = "CONCEALED_DAMAGE_BREAKAGE";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_BURSTING_OR_TEARING"] = "CONCEALED_DAMAGE_BURSTING_OR_TEARING";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_COLLISION_OR_OVERTURN"] = "CONCEALED_DAMAGE_COLLISION_OR_OVERTURN";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_CONTAMINATION"] = "CONCEALED_DAMAGE_CONTAMINATION";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_CRUSHING"] = "CONCEALED_DAMAGE_CRUSHING";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_DENTING"] = "CONCEALED_DAMAGE_DENTING";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_FIRE"] = "CONCEALED_DAMAGE_FIRE";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_FORKLIFT_DAMAGE"] = "CONCEALED_DAMAGE_FORKLIFT_DAMAGE";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_LEAKAGE"] = "CONCEALED_DAMAGE_LEAKAGE";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_MARRING_OR_SCRATCHING"] = "CONCEALED_DAMAGE_MARRING_OR_SCRATCHING";
    eClaimApiV1CauseOfLoss["CONCEALED_DAMAGE_ROUGH_HANDLING"] = "CONCEALED_DAMAGE_ROUGH_HANDLING";
    eClaimApiV1CauseOfLoss["EXTREMES_OF_TEMPERATURE"] = "EXTREMES_OF_TEMPERATURE";
    eClaimApiV1CauseOfLoss["REEFER_BREAKDOWN"] = "REEFER_BREAKDOWN";
    eClaimApiV1CauseOfLoss["THEFT"] = "THEFT";
    eClaimApiV1CauseOfLoss["SHORTAGE"] = "SHORTAGE";
    eClaimApiV1CauseOfLoss["NON_DELIVERY"] = "NON_DELIVERY";
    eClaimApiV1CauseOfLoss["OTHER"] = "OTHER";
})(eClaimApiV1CauseOfLoss = exports.eClaimApiV1CauseOfLoss || (exports.eClaimApiV1CauseOfLoss = {}));
var eClaimApiV1DocumentType;
(function (eClaimApiV1DocumentType) {
    eClaimApiV1DocumentType["COMMERCIAL_INVOICE"] = "COMMERCIAL_INVOICE";
    eClaimApiV1DocumentType["PACKING_LIST"] = "PACKING_LIST";
    eClaimApiV1DocumentType["INLAND_BILL_OF_LADING"] = "INLAND_BILL_OF_LADING";
    eClaimApiV1DocumentType["CONSIGNMENT_NOTE"] = "CONSIGNMENT_NOTE";
    eClaimApiV1DocumentType["DELIVERY_RECEIPTS"] = "DELIVERY_RECEIPTS";
    eClaimApiV1DocumentType["POLICE_REPORT"] = "POLICE_REPORT";
    eClaimApiV1DocumentType["REEFER_TEMP_LOG"] = "REEFER_TEMP_LOG";
    eClaimApiV1DocumentType["FIRE_REPORT"] = "FIRE_REPORT";
    eClaimApiV1DocumentType["SEA_WAYBILL"] = "SEA_WAYBILL";
    eClaimApiV1DocumentType["NOTICE_OF_CLAIM_TO_CARRIER"] = "NOTICE_OF_CLAIM_TO_CARRIER";
    eClaimApiV1DocumentType["VESSEL_OUTTURN_REPORT"] = "VESSEL_OUTTURN_REPORT";
    eClaimApiV1DocumentType["CONTAINER_DAMAGE_REPORT"] = "CONTAINER_DAMAGE_REPORT";
    eClaimApiV1DocumentType["INTERCHANGE_RECEIPT"] = "INTERCHANGE_RECEIPT";
    eClaimApiV1DocumentType["MASTERS_STATEMENT_OF_FACTS"] = "MASTERS_STATEMENT_OF_FACTS";
    eClaimApiV1DocumentType["PRESHIPMENT_SURVEYS"] = "PRESHIPMENT_SURVEYS";
    eClaimApiV1DocumentType["PERISHABLE_GOODS_HANDLING_INSTRUCTIONS"] = "PERISHABLE_GOODS_HANDLING_INSTRUCTIONS";
    eClaimApiV1DocumentType["CONDEMNATION_CERTIFICATES"] = "CONDEMNATION_CERTIFICATES";
    eClaimApiV1DocumentType["SHIPS_TEMPERATURE_LOGS"] = "SHIPS_TEMPERATURE_LOGS";
    eClaimApiV1DocumentType["CERTIFICATE_OF_ORIGIN"] = "CERTIFICATE_OF_ORIGIN";
    eClaimApiV1DocumentType["RAILWAY_BILL_OF_LADING"] = "RAILWAY_BILL_OF_LADING";
    eClaimApiV1DocumentType["MULTIMODAL_BILL_OF_LADING"] = "MULTIMODAL_BILL_OF_LADING";
    eClaimApiV1DocumentType["FIATA_MULTIMODEL_BILL_OF_LADING"] = "FIATA_MULTIMODEL_BILL_OF_LADING";
    eClaimApiV1DocumentType["CIM_SMGS_CONSIGNMENT_NOTE"] = "CIM_SMGS_CONSIGNMENT_NOTE";
    eClaimApiV1DocumentType["PHOTO"] = "PHOTO";
    eClaimApiV1DocumentType["OTHER"] = "OTHER";
    eClaimApiV1DocumentType["FREIGHT_INVOICE"] = "FREIGHT_INVOICE";
})(eClaimApiV1DocumentType = exports.eClaimApiV1DocumentType || (exports.eClaimApiV1DocumentType = {}));
var eClaimApiV1ClaimStatus;
(function (eClaimApiV1ClaimStatus) {
    eClaimApiV1ClaimStatus["DRAFT_LOSS_NOTICE"] = "DRAFT_LOSS_NOTICE";
    eClaimApiV1ClaimStatus["AWAITING_DOCUMENTS"] = "AWAITING_DOCUMENTS";
    eClaimApiV1ClaimStatus["UNDER_REVIEW"] = "UNDER_REVIEW";
    eClaimApiV1ClaimStatus["PAYMENT_PROPOSED"] = "PAYMENT_PROPOSED";
    eClaimApiV1ClaimStatus["PAID"] = "PAID";
    eClaimApiV1ClaimStatus["REJECTED"] = "REJECTED";
    eClaimApiV1ClaimStatus["WITHDRAWN"] = "WITHDRAWN";
    eClaimApiV1ClaimStatus["PAYMENT_PROCESSING"] = "PAYMENT_PROCESSING";
})(eClaimApiV1ClaimStatus = exports.eClaimApiV1ClaimStatus || (exports.eClaimApiV1ClaimStatus = {}));
var eClaimApiV1ClaimAction;
(function (eClaimApiV1ClaimAction) {
    eClaimApiV1ClaimAction["SAVE_DRAFT_LOSS_NOTICE"] = "SAVE_DRAFT_LOSS_NOTICE";
    eClaimApiV1ClaimAction["SUBMIT_LOSS_NOTICE"] = "SUBMIT_LOSS_NOTICE";
    eClaimApiV1ClaimAction["SUBMIT_FOR_REVIEW"] = "SUBMIT_FOR_REVIEW";
    eClaimApiV1ClaimAction["WITHDRAW"] = "WITHDRAW";
    eClaimApiV1ClaimAction["ACCEPT_PAYMENT_PROPOSAL"] = "ACCEPT_PAYMENT_PROPOSAL";
    eClaimApiV1ClaimAction["REJECT_PAYMENT_PROPOSAL"] = "REJECT_PAYMENT_PROPOSAL";
})(eClaimApiV1ClaimAction = exports.eClaimApiV1ClaimAction || (exports.eClaimApiV1ClaimAction = {}));
var eClaimApiV1Parties;
(function (eClaimApiV1Parties) {
    eClaimApiV1Parties["USER"] = "USER";
    eClaimApiV1Parties["ASSURED"] = "ASSURED";
    eClaimApiV1Parties["LOSS_PAYEE"] = "LOSS_PAYEE";
    eClaimApiV1Parties["CLAIM_CONTACT"] = "CLAIM_CONTACT";
})(eClaimApiV1Parties = exports.eClaimApiV1Parties || (exports.eClaimApiV1Parties = {}));
var eCauseOfDamage;
(function (eCauseOfDamage) {
    eCauseOfDamage["BENDING_OR_TWISTING"] = "bendingOrTwisting";
    eCauseOfDamage["BREAKAGE"] = "breakage";
    eCauseOfDamage["BURSTING_OR_TEARING"] = "burstingOrTearing";
    eCauseOfDamage["COLLISION_OR_OVERTURN"] = "collisionOrOverturn";
    eCauseOfDamage["CONTAMINATION"] = "contamination";
    eCauseOfDamage["CRUSHING"] = "crushing";
    eCauseOfDamage["DENTING"] = "denting";
    eCauseOfDamage["FIRE"] = "fire";
    eCauseOfDamage["FORKLIFT_DAMAGE"] = "forkliftDamage";
    eCauseOfDamage["LEAKAGE"] = "leakage";
    eCauseOfDamage["MARRING_OR_SCRATCHING"] = "marringOrScratching";
    eCauseOfDamage["ROUGH_HANDLING"] = "roughHandling";
})(eCauseOfDamage = exports.eCauseOfDamage || (exports.eCauseOfDamage = {}));
var eCauseOfTemperatureRelatedIssue;
(function (eCauseOfTemperatureRelatedIssue) {
    eCauseOfTemperatureRelatedIssue["EXTREMES_OF_TEMPERATURE"] = "extremesOfTemperature";
    eCauseOfTemperatureRelatedIssue["REEFER_BREAKDOWN"] = "reeferBreakdown";
})(eCauseOfTemperatureRelatedIssue = exports.eCauseOfTemperatureRelatedIssue || (exports.eCauseOfTemperatureRelatedIssue = {}));
class ClaimApiV1Document {
    constructor(id, documentType, filename, fileSize, filePath, user, notes) {
        this.id = id;
        this.documentType = documentType;
        this.filename = filename;
        this.fileSize = fileSize;
        this.filePath = filePath;
        this.user = user;
        this.notes = notes;
    }
    static fromObj(data) {
        return new ClaimApiV1Document(data.id, data.documentType, data.filename, data.fileSize, data.filePath, user_1.default.fromObj(data.user), data.notes);
    }
}
exports.ClaimApiV1Document = ClaimApiV1Document;
class ClaimApiV1Message {
    constructor(id, message, user, documentIds) {
        this.id = id;
        this.message = message;
        this.user = user;
        this.documentIds = documentIds;
    }
    static fromObj(data) {
        return new ClaimApiV1Message(data.id, data.message, user_1.default.fromObj(data.user), data.documentIds);
    }
}
exports.ClaimApiV1Message = ClaimApiV1Message;
//# sourceMappingURL=index.js.map